/**
 * ItemDetail component
 * @returns <ItemDetail />
 */

import Badge from "./Badge";
import Button from "./Button";
import BoxWithBorder from "./BoxWithBorder";
import Discount from "./Discount";
import DiscountDetail from "./DiscountDetail";
import Select from "./Select";
import InputContainer from "./InputContainer";
// import Description from "./Description";
import LegalInformation from "./LegalInformation";
import Modal from "./Modal";
import Drawer from "./Drawer";
import Toast from "./Toast";

import { useMediaQuery } from "usehooks-ts";
import { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useAddProductMutation } from "../redux/apiSlice";
import {
    setAllowedMaintenances,
    removeAllowedMaintenances,
} from "../redux/cartSlice";
import { toastConfig } from "../mock/data";
import { useGetCartQuery } from "../redux/apiSlice";
// import { isItemInCart } from "../scripts/helpers/cartFunctions";

const ItemDetailMantencion = ({ item, doc }) => {
    const dispatch = useDispatch();
    const allowedMaintenances = useSelector(
        (state) => state.cart.allowedMaintenances
    );
    const { data: cart } = useGetCartQuery();

    const {
        title, // string
        detailSubtitle: subtitle, // string
        image, // string
        secondaryImage, // string
        description, // object
        legalInfo, // array of strings
        mantenciones,
        currency,
        discount,
        type,
        id,
        options,
    } = item;

    const initialState = {
        id,
        type,
        title,
        image,
        description,
        price: null,
        totalPrice: null,
        quantity: 1,
        extra_info: null,
    };

    let itemAdded;
    const [addProduct] = useAddProductMutation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [itemToAddToCart, setItemAddToCart] = useState(initialState);

    const match = useMediaQuery("(min-width: 768px)");

    const getContent = (options, id) => {
        const { to_do, inspect, change, image } = options.find(
            (option) => option.id === Number(id)
        );

        return {
            to_do,
            inspect,
            change,
            image,
        };
    };

    const getPrice = (options, id) => {
        const selectedOption = options.find((option) => option.id === Number(id));
        const hasDiscountedPrice =
            selectedOption?.discount_price !== null &&
            selectedOption?.discount_price !== undefined &&
            selectedOption?.discount_price !== "";
        const originalPrice = Number(selectedOption?.price || 0);
        const discountPrice = hasDiscountedPrice
            ? Number(selectedOption.discount_price)
            : null;

        return {
            originalPrice,
            discountPrice,
            finalPrice: hasDiscountedPrice ? discountPrice : originalPrice,
        };
    };

    const toggleModalHandler = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleDrawerHandler = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    let modalContent = (
        <>
            <div className="modal__content">
                <h3>Realizar</h3>

                <div
                    dangerouslySetInnerHTML={{ __html: itemToAddToCart.to_do }}
                />
            </div>

            <div className="modal__content">
                <h3>Inspeccionar</h3>

                <div
                    dangerouslySetInnerHTML={{
                        __html: itemToAddToCart.inspect,
                    }}
                />
            </div>

            <div className="modal__content">
                <h3>Cambio</h3>

                <div
                    dangerouslySetInnerHTML={{ __html: itemToAddToCart.change }}
                />

                {itemToAddToCart.modal_image ? (
                    <img src={itemToAddToCart.modal_image} alt="Lexus" />
                ) : (
                    ""
                )}
            </div>
        </>
    );

    const mantencionChangeHandler = (id) => {
        const { originalPrice, discountPrice, finalPrice } = getPrice(options, id);

        const { to_do, inspect, change, image } = getContent(options, id);

        const extra_info_data = {
            version: title,
            mantencion: mantenciones.find(
                (mantencion) => mantencion.dataValue === Number(id)
            ).label,
        };

        setItemAddToCart((prevState) => {
            return {
                ...prevState,
                id,
                price: finalPrice,
                totalPrice: finalPrice,
                originalPrice,
                discount_price: discountPrice,
                to_do,
                inspect,
                change,
                extra_info: JSON.stringify(extra_info_data),
                modal_image: image,
            };
        });
    };

    const addToCartHandler = () => {
        if (!cart) {
            return;
        } else {
            if (allowedMaintenances || allowedMaintenances === null) {
                // Si hay items en el carrito, tengo que chequear que sea la misma version pero no la misma mantencion
                const is_version_in_cart = cart.items.some((item) => {
                    return JSON.parse(item.extra_info).version === title;
                });

                const is_the_same_mantencion = cart.items.some(
                    (item) =>
                        JSON.parse(item.extra_info).mantencion ===
                        JSON.parse(itemToAddToCart.extra_info).mantencion
                );

                if (cart.items.length === 0) {
                    // console.log("items vacio");
                    // No hay productos en el carrito
                    if (!is_version_in_cart && !is_the_same_mantencion) {
                        // console.log("cart vacio, se agrega 1 prod");

                        toast(
                            <Toast
                                type="add-product"
                                title={"Agregaste aal carrito"}
                                product={itemToAddToCart}
                                totalPrice={itemToAddToCart.totalPrice}
                            />,
                            toastConfig
                        );
                        addProduct({
                            product_type: itemToAddToCart.type,
                            product_id: itemToAddToCart.id,
                            quantity: itemToAddToCart.quantity,
                            extra_info: itemToAddToCart.extra_info,
                        });

                        dispatch(setAllowedMaintenances());
                    }
                } else {
                    // console.log("items en el carrito");
                    if (is_version_in_cart && !is_the_same_mantencion) {
                        toast(
                            <Toast
                                type="add-product"
                                title={"Agregaste al carrito"}
                                product={itemToAddToCart}
                                totalPrice={itemToAddToCart.totalPrice}
                            />,
                            toastConfig
                        );

                        addProduct({
                            product_type: itemToAddToCart.type,
                            product_id: itemToAddToCart.id,
                            quantity: itemToAddToCart.quantity,
                            extra_info: itemToAddToCart.extra_info,
                        });

                        dispatch(setAllowedMaintenances());

                        return;
                    }
                    // en el carrito ya hay items
                    if (is_version_in_cart && is_the_same_mantencion) {
                        toast(
                            <Toast
                                type="add-product"
                                title={"Error al agregar al carrito"}
                                error={
                                    "No puedes agregar dos veces la misma mantención sobre el mismo auto."
                                }
                            />,
                            toastConfig
                        );

                        return;
                    }

                    if (!is_version_in_cart) {
                        // console.log(
                        //     "en el carrito hay productos pero es otro diferente, se agrega 1 mantencion"
                        // );
                        toast(
                            <Toast
                                type="add-product"
                                title={"Error al agregar al carrito"}
                                error={
                                    "No puedes agregar mantenciones de dos versiones diferentes"
                                }
                            />,
                            toastConfig
                        );

                        return;
                    }
                }
            } else {
                // console.log("no se puede agregar mantencion");

                toast(
                    <Toast
                        type="add-product"
                        title={"Error al agregar al carrito"}
                        error={
                            "No puedes agregar mantenciones porque tienes accesorios o merchandising."
                        }
                    />,
                    toastConfig
                );
            }
        }
    };

    return (
        <section className="item-detail">
            <div className="wrapper">
                <div className="item-detail__grid">
                    <div className="box-left">
                        <div className="title-container mobile-only">
                            {/* OPTIONAL: Badges - stock */}
                            {/* Out of stock */}
                            {item.stock === 0 && (
                                <Badge
                                    type="badge-detail"
                                    text="Agotado"
                                    backgroundColor="#454545"
                                />
                            )}
                            {/* Low stock */}
                            {item.stock === 1 && (
                                <Badge
                                    type="badge-detail"
                                    text="Último disponible"
                                    backgroundColor="#AD0B00"
                                />
                            )}

                            {/* Main title in desktop */}
                            <h1 className="title">{title}</h1>

                            {/* OPTIONAL: Subtitle */}
                            {subtitle && <p className="subtitle">{subtitle}</p>}
                        </div>

                        {/* Main image */}
                        <img
                            className="item-detail__image"
                            src={image}
                            alt=""
                        />

                        {/* Badge - product type */}
                        <Badge
                            type={"maintenance"}
                            text={"Servicio de Mantención"}
                            backgroundColor={"#F7F7F7"}
                        />

                        {/* OPTIONAL: Description */}
                        {/* {description && <Description {...description} />} */}

                        {/* OPTIONAL: Secondary image */}
                        {/* {secondaryImage && <img className="item-detail__image" src={image} alt="" />} */}
                    </div>

                    <div className={"box-right --mantencion"}>
                        <div className="title-container desktop-only">
                            {/* OPTIONAL: Badges - stock*/}
                            {/* Out of stock */}
                            {item.stock === 0 && (
                                <Badge
                                    type="badge-detail"
                                    text="Agotado"
                                    backgroundColor="#454545"
                                />
                            )}
                            {/* Low stock */}
                            {item.stock === 1 && (
                                <Badge
                                    type="badge-detail"
                                    text="Último disponible"
                                    backgroundColor="#AD0B00"
                                />
                            )}

                            {/* Main title in desktop */}
                            <h1 className="title">{title}</h1>

                            {/* OPTIONAL: Subtitle */}
                            {subtitle && <p className="subtitle">{subtitle}</p>}
                        </div>

                        {/* Mantenciones */}
                        <InputContainer
                            title={""}
                            subtitle={""}
                            extraClass={""}
                        >
                            <Select
                                type={"select"}
                                dropdownItems={mantenciones}
                                name={"mantencion-select"}
                                label={"Mantención"}
                                placeholder={"Selecciona una mantención"}
                                selectChangeHandler={mantencionChangeHandler}
                            />

                            {/* OPTIONAL: Modal Button */}
                            <Button
                                tag={"link"}
                                text={"Quiero saber que incluye"}
                                extraClass={"quiero-saber-que-incluye"}
                                hasIcon={true}
                                onClick={
                                    match
                                        ? toggleModalHandler
                                        : toggleDrawerHandler
                                }
                            />
                        </InputContainer>

                        {/* Price */}
                        <InputContainer
                            title={"PRECIO ONLINE"}
                            extraClass="price-and-discount"
                        >
                            {/* Price box */}
                            <BoxWithBorder
                                type={"price"}
                                currency={currency}
                                price={itemToAddToCart.price}
                                label={"PRECIO ONLINE"}
                            />

                            {/* OPTIONAL: Discount */}
                            {discount && <Discount text={discount} />}
                        </InputContainer>
                        {itemToAddToCart.discount_price !== null &&
                            itemToAddToCart.discount_price !== undefined && (
                            <DiscountDetail
                                originalPrice={itemToAddToCart.originalPrice}
                                discount={itemToAddToCart.discount_price}
                            />
                        )}

                        {/* Agregar al carrito */}
                        <InputContainer
                            title={""}
                            subtitle={""}
                            extraClass="add-to-cart"
                        >
                            <Button
                                tag={"button"}
                                onClick={() =>
                                    addToCartHandler(() =>
                                        addToCartHandler(itemToAddToCart)
                                    )
                                }
                                text={"Agregar al carrito"}
                                hasIcon={true}
                                extraClass={"--btn-full-width"}
                                disabled={!itemToAddToCart.price}
                            />
                        </InputContainer>
                    </div>
                </div>
            </div>
            <LegalInformation doc={doc} texts={legalInfo} id={id} />
            {/* Modal */}
            {isModalOpen && (
                <Modal
                    title="La mantención incluye"
                    isOpen={isModalOpen}
                    content={modalContent}
                    close={toggleModalHandler}
                />
            )}

            {/* Drawer */}
            {isDrawerOpen && (
                <Drawer
                    title="La mantención incluye"
                    isOpen={isDrawerOpen}
                    content={drawerContent}
                    close={toggleDrawerHandler}
                />
            )}
        </section>
    );
};

export default ItemDetailMantencion;
